module.exports = __webpack_public_path__ + "static/media/image-16x9.4f482b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/image-16x9.png
// module id = 935
// module chunks = 0